import React, { useCallback } from 'react';
import MUISingleCheckbox from '../../../uikit/inputs/SingleCheckbox';
import { noop } from '../../../utils/noop';
// @todo Implement correct label (click at label should check box)
export var SingleCheckbox = function (props) {
    var label = props.label, name = props.name, _a = props.value, value = _a === void 0 ? false : _a, _b = props.onChange, onChange = _b === void 0 ? noop : _b, error = props.error, disabled = props.disabled;
    var handleCheckboxChange = useCallback(function (e) {
        onChange(e.target.checked, e);
    }, [onChange]);
    return (React.createElement(MUISingleCheckbox, { id: name, name: name, value: name, checked: value, onChange: handleCheckboxChange, label: label, error: error, disabled: disabled }));
};
